import { useEffect, useState } from 'react';

import { Entitlements } from '@trello/entitlements';
import { useGetExperimentValue } from '@trello/feature-gate-client';

import { usePersonalProductivityCohortValue } from 'app/src/components/PersonalProductivityBeta';
import { useMonetizationWorkspaceOfferingFragment } from './MonetizationWorkspaceOfferingFragment.generated';

export const useIsEligibleForMonetizationMessagingRefresh = ({
  workspaceId,
}: {
  workspaceId: string;
}) => {
  const [fireExposureEvent, setFireExposureEvent] = useState(false);
  const personalProductivityCohortValue = usePersonalProductivityCohortValue();

  const { cohort } = useGetExperimentValue({
    experimentName: 'ghost_monetization_messaging',
    parameter: 'cohort',
    fireExposureEvent,
  });

  const { data: workspaceData } = useMonetizationWorkspaceOfferingFragment({
    from: { id: workspaceId },
  });

  const isEligibleWorkspace =
    personalProductivityCohortValue === 'ga' &&
    !!workspaceData?.offering &&
    !Entitlements.isEnterprise(workspaceData.offering);

  useEffect(() => {
    if (isEligibleWorkspace && !fireExposureEvent) {
      setFireExposureEvent(true);
    }
  }, [isEligibleWorkspace, fireExposureEvent]);

  return {
    isEligibleWorkspaceForRefresh:
      isEligibleWorkspace && cohort === 'experiment',
  };
};
